import Icon from "../../../utils/Icon";
import {RiDeleteBin5Line} from "react-icons/ri";
import {SlArrowDown} from "react-icons/sl";
import React from "react";
import FilterItem from "../FilterItem/FilterItem";
import classnames from "classnames";
import styles from "../Filters/Filters.module.scss";


const FiltersMobile = ({
                           isMobile,
                           filterRef,
                           showMobileFilter,
                           setShowMobileFilter,
                           SelectedItem,
                           selectedTabOption,
                           clearFilters = () => {},
                           selectedOptions,
                           expandedSubCategories,
                           expandedCategories,
                           filterItems,
                           toggleCategoryExpansion = () => {},
                           toggleSubCategoryExpansion = () => {},
                           handleShowFilterSection = () => {},
                           handleRemoveFilterOption = () => {},
                           toggleCategorySelection,
                           handleFilterOptionChange,
                           handleRadioFilterOptionChange,
                           isCheckboxVisible,
                           lang
                       }) => {


    function SelectedItem({name, onRemove}) {
        return (
            <div className={classnames(styles.selected_item)}>
                {name}
                <button className="remove-button" onClick={onRemove}>
                    ×
                </button>
            </div>
        );
    }
    return (
        <>
            {isMobile}
            {/*left filter tab for mobile*/}
            <div ref={filterRef} className={`mobile-filter-wrapper ${showMobileFilter ? 'show' : ''}`}>
                <div className="mobile-filter-header">
                    <div className="header-filter d-flex align-items-center justify-content-start pt-2 pt-md-0">
                        <Icon name="filter" className="filter-icon" width="23px" height="23px"/>
                        <div className="p2">{lang === "en" ? "Filters":"Φίλτρα"}</div>
                    </div>
                    <button className="close-button" onClick={() => setShowMobileFilter(false)}>×</button>
                </div>

                {/* Scrollable filter content */}
                <div className="filter-content">
                    {selectedTabOption !== 'articles' && selectedTabOption !== 'support' &&
                        <div>
                            {/* Filter */}
                            <div className="col-12 search-filter-container search-filter-panel-col mt-1 mt-sm-1 mt-md-1 mt-lg-4 mt-xl-4 normalize">

                                <div className="header-filter d-flex align-items-center justify-content-between pt-2 pt-md-0" onClick={handleShowFilterSection}>
                                    <div className="p3">{lang === "en"? "Applied filters":"Φίλτρα σε εφαρμογή"}</div>
                                    <RiDeleteBin5Line
                                        className="clear-filter-button"
                                        style={{color: '#000'}}
                                        onClick={() => clearFilters()}
                                        size={20}
                                    />
                                </div>
                                <div className="selected-items-container">
                                    <div className={classnames(styles.selected_filters)}>
                                        {Object.entries(selectedOptions).flatMap(([category, values]) =>
                                            values.map((value, index) => (
                                                <SelectedItem
                                                    key={`${category}-${value.category}-${index}`}
                                                    name={value.displayName}
                                                    onRemove={() => handleRemoveFilterOption(category, value.category)}
                                                />
                                            ))
                                        )}
                                    </div>
                                    {filterItems.map((item, index) => {
                                        const isExpanded = expandedCategories[item.title];
                                        const isSubExpanded = expandedSubCategories[item.title];
                                        return (
                                            <FilterItem
                                                clearFilters={clearFilters}
                                                item={item}
                                                isExpanded={isExpanded}
                                                toggleCategoryExpansion={toggleCategoryExpansion}
                                                toggleSubCategoryExpansion={toggleSubCategoryExpansion}
                                                selectedOptions={selectedOptions}
                                                key={index}
                                                isSubExpanded={isSubExpanded}
                                                handleFilterOptionChange={handleFilterOptionChange}
                                                handleRadioFilterOptionChange={handleRadioFilterOptionChange}
                                                expandedSubCategories={expandedSubCategories}
                                                toggleCategorySelection={toggleCategorySelection}
                                                isCheckboxVisible={isCheckboxVisible}
                                            />
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    }
                </div>

                {/* Footer with apply button */}
                <div className="filter-footer">
                    <button className="button-apply-filters" onClick={() => setShowMobileFilter(false)}>
                        Εφαρμογή Φίλτρων
                    </button>
                </div>

            </div>

            {/* Overlay */}
            {showMobileFilter && <div className="overlay" onClick={() => setShowMobileFilter(false)}></div> }
        </>
    );
};

export default FiltersMobile;